import React from "react";
import {
    Card, CardHeader,
    CardBody,
} from "reactstrap";
import Chart from 'chart.js';
import { GetOpComparisonList } from "../../api/OperatorComparisonApi";


class OperatorComparison extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dateValue: "day",
            data: [],
            chartData: null,

            startDate: this.props.DataFromDashboard.selectedStartDate,
            endDate: this.props.DataFromDashboard.selectedEndDate,
            operator: this.props.DataFromDashboard.paramOperator,
            productType: this.props.DataFromDashboard.paramType,
            companyId: this.props.DataFromDashboard.companyId,
            roleId: this.props.DataFromDashboard.roleId,
            userId: this.props.DataFromDashboard.userId
        }
        this.canvasRef = React.createRef();
        this.colorArray = ['lime', 'teal', 'aqua', 'fuchsia', 'yellow', 'red', 'maroon', 'purple', 'lightblue', 'lightgreen', 'pink'];

    }

    bindData() {
        const { data } = this.state;
        let operatorNameArry = [];
        let sellPriceArry = [];
        data.forEach((item) => {
            operatorNameArry.push(item.operatorName);
            sellPriceArry.push(item.sellPrice);
        });

        let totalSellPrice = 0;
        for (let i = 0; i < sellPriceArry.length; i++) {
          totalSellPrice += sellPriceArry[i];
        }

        const labels = operatorNameArry.map((name, index) => `${name} - ${sellPriceArry[index].toLocaleString('en')}`);

        this.setState({ chartData: { ...this.state.chartData, labels: labels },
            totalSellPrice: totalSellPrice.toLocaleString('en')
         },);

        let DataSetAry = [];

        for (let i = 0; i < operatorNameArry.length; i++) {
            DataSetAry[0] = {
                backgroundColor: this.colorArray,
                borderColor: "rgba(0,123,255,1)",
                pointBackgroundColor: "#ffffff",
                pointHoverBackgroundColor: "rgb(0,123,255)",
                borderWidth: 1.5,
                pointRadius: 0,
                pointHoverRadius: 5,

                data: sellPriceArry,
            };
        }


        this.setState({ chartData: { ...this.state.chartData, datasets: DataSetAry } },);


    }

    async componentDidMount() {
        const resdata = await GetOpComparisonList(this.state);
        this.setState({ data: Array.isArray(resdata) ? resdata : [] });
        this.bindData();

        if(this.state.data.length !== 0){
             const chartOptions = {

            ...{
                legend: {
                    position: "left",
                    labels: {
                        padding: 15,
                        boxWidth: 15
                    }
                },
                cutoutPercentage: 0,
                tooltips: {
                    custom: false,
                    mode: "index",
                    position: "nearest",
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const label = data.labels[tooltipItem.index];
                            return label;
                          }
                    }
                }
            },
        }

        const BlogUsersOverview = new Chart(this.canvasRef.current, {
            type: 'pie',
            data: this.state.chartData,
            options: chartOptions
        });
        BlogUsersOverview.render();
        }
       
    }

    updateState(prop, value) {
        this.setState({ [prop]: value });
    }

    render() {
        return (
            <Card small className="h-100">
                <CardHeader className="border-bottom">
                    <h6 className="m-0">Operator Comparison</h6>
                </CardHeader>
                <CardBody className="d-flex py-0">
                {this.state.data.length === 0 ? 
                (
                    <div className="m-auto text-muted" style={{
                        fontSize: '1.2rem', height: '200px', padding: '20px', margin: '10px',
                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                      }}>
                        No Data
                    </div>
                ) : (
                    <div className="blog-users-by-device m-auto">
                         <canvas
                        height="200"
                        ref={this.canvasRef}
                        // className="blog-users-by-device m-auto"
                    />
                        Total Amount : {this.state.totalSellPrice}
                        </div>
                    
                    
                )
            }

                </CardBody>
            </Card>

            
        );
    }
}


export default OperatorComparison;

